<template>
    <div class="service-list-view">
        <h1 class="app-h1">
            Список услуг
        </h1>

        <div class="service-list-view__toolbar">
            <el-input
                v-model.trim="search"
                class="service-list-view__search"
                clearable
                placeholder="Поиск"
            />

            <el-button
                type="primary"
                @click="_openAddForm"
            >
                Добавить
            </el-button>
        </div>

        <service-list
            ref="list"
            :search="search"
            @edit="_onServiceEdit"
        />
        <service-form-popup
            ref="form"
            @added="_onServiceAdded"
            @updated="_onServiceUpdated"
        />
    </div>
</template>

<script>
import ServiceList from '../components/ServiceList';
import breadcrumbs from '@/mixins/breadcrumbs';
import { ROUTES } from '@/enums';
import ServiceFormPopup from '@/modules/service/components/ServiceFormPopup';

export default {
    name: 'ServiceListView',

    components: {
        ServiceFormPopup,
        ServiceList
    },

    mixins: [
        breadcrumbs
    ],

    data() {
        return {
            search: ''
        };
    },

    computed: {
        $breadcrumbs() {
            return [
                {
                    title: 'Услуги',
                    route: null
                },
                {
                    title: 'Список услуг',
                    route: ROUTES.SERVICE.LIST
                }
            ];
        }
    },

    methods: {
        _onServiceEdit() {
            this.$refs.form.open();
        },

        _openAddForm() {
            this.$refs.form.open();
        },

        /**
         * @param {ServiceResource} service
         * @private
         */
        _onServiceAdded({ service }) {
            this.$message.success(`Услуга "${service.attributes.title}" добавлена успешно`);
            this.$refs.list.reload();
        },

        _onServiceUpdated({ service }) {
            this.$message.success(`Услуга "${service.attributes.title}" обновлена успешно`);
            this.$refs.list.reload();
        }
    }
};
</script>

<style lang="scss">
@import "@vars";

.service-list-view {
    &__toolbar {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
    }

    &__search {
        max-width: 300px;
        width: 100%;
    }
}

</style>
